export const ORDER_CHECK_PRICE_GET = '[ORDER CHECK_PRICE] GET';
export const ORDER_CHECK_PRICE_SUCCESS = '[ORDER CHECK_PRICE] SUCCESS';
export const ORDER_CHECK_PRICE_FAIL = '[ORDER CHECK_PRICE] FAIL';
